export enum Mode {
    Advanced = "advanced",
    Basic = "basic"
}
